import request from './request';

const document = {
	async getDocument(id) {
		const response = await request.get(`/app/documents/id?id=${id}`);
		return response;
	},
	async createDocument(body) {
		const res = await request.post('/app/documents', body);
		return res;
	},
	async updateDocument(id, body) {
		const res = await request.patch(`/app/documents/id?id=${id}`, body);
		return res;
	}
};

export default document;